import React from 'react';

/**
 * Timeline — vertical activity feed of events.
 *
 * Props:
 *   items: Array<{ id, icon?, title, meta?, description?, tone? }>
 *     tone: 'default'|'primary'|'success'|'warning'|'danger'  — marker color
 */
const Timeline = ({ items = [], className = '' }) => (
  <ol className={`ps-timeline ${className}`.trim()}>
    {items.map((it, i) => (
      <li key={it.id ?? i} className={`ps-timeline__item ps-timeline__item--${it.tone || 'default'}`}>
        <span className="ps-timeline__marker">
          {it.icon || <span className="ps-timeline__dot" />}
        </span>
        <div className="ps-timeline__content">
          <div className="ps-timeline__head">
            <span className="ps-timeline__title">{it.title}</span>
            {it.meta && <span className="ps-timeline__meta">{it.meta}</span>}
          </div>
          {it.description && <div className="ps-timeline__desc">{it.description}</div>}
        </div>
      </li>
    ))}
  </ol>
);

export default Timeline;
